import React, { Component } from 'react';
import Button from '../../../../../components/Button';
import ExcelUploadForm from '../../../../../components/form/ExcelUploadForm';
import Anchor from '../../../../../components/link/Anchor';
import Panel from '../../../../../components/outline/Panel';
import TableTransfer from '../../../../../components/input/TableTransfer';
import { SEARCH_WORD_TEMPLATE_XLSX_URL } from '../../../../../constants/service/common/staticFileUrlConstants';
import { comparePrePropsAndNextProps } from '../../../../../lib/common';
import { _LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import {
  RECOMMEND_SEARCH_WORD_ITEM_LIST_FILTER_OPTION_MODEL,
  RECOMMEND_SEARCH_WORD_ITEM_LIST_SORT_OPTION_MODEL,
} from '../../../../../store/modules/recommend/searchWord/models';
import { columns } from './columns';
import './RecommendSearchWordSaveItemList.scss';

class RecommendSearchWordSaveItemList extends Component {
  /**
   *  Component 의 변경되는 props 와 state 가 있을 경우에만,
   *  render 메소드를 호출할 수 있도록 함
   */
  shouldComponentUpdate = (nextProps, nextState) => {
    return comparePrePropsAndNextProps([
      [nextProps, this.props],
      [nextState, this.state],
    ]);
  };

  render() {
    const {
      recommendSearchWordItemList,
      getRecommendSearchWordItemList,
      selectRecommendSearchWordItemList,
      onDragEndSelectRecommendSearchWordItemList,
      getRecommendSearchWordItemListExcelDownload,
      getSelectedRecommendSearchWordItemListExcelDownload,
      setRecommendSearchWordItemListExcelUpload,
    } = this.props;
    const { itemList, selectedItemList } = recommendSearchWordItemList;

    return (
      <Panel className="recommend-search-word-save-item-list">
        <div className="panel-header">
          <div className="title">추천 검색 키워드 아이템 리스트</div>
        </div>

        <div className="panel-body">
          <TableTransfer
            dataSource={itemList.list}
            operations={['연결', '해제']}
            leftTitle="검색 키워드 리스트"
            rightTitle="선택된 검색 키워드 리스트"
            leftTableProps={{
              columns: (utils) =>
                columns({
                  ...utils,
                  isFilter: true,
                }),
              headInfo: (
                <div className="recommend-search-word-item-head">
                  <div className="excel-button-list">
                    <Button
                      isRadius
                      color="light"
                      text="엑셀 다운로드"
                      onClick={getRecommendSearchWordItemListExcelDownload}
                    />
                  </div>
                </div>
              ),
              rowClassName: (record) => (record.uncheckable ? 'uncheckable' : null),
              getList: getRecommendSearchWordItemList,
              pagination: itemList.pagination,
              sortOption: itemList.sortOption,
              filterOption: itemList.filterOption,
              initialOption: {
                filterOption: RECOMMEND_SEARCH_WORD_ITEM_LIST_FILTER_OPTION_MODEL,
                sortOption: RECOMMEND_SEARCH_WORD_ITEM_LIST_SORT_OPTION_MODEL,
                pagination: _LIST_PAGINATION_MODEL,
              },
            }}
            rightTableProps={{
              columns: (utils) =>
                columns({
                  ...utils,
                }),
              headInfo: (
                <div className="selected-recommend-search-word-item-head">
                  <div className="selected-recommend-search-word-item-count">
                    선택된 아이템 개수 <span>{selectedItemList.list.length}</span>
                  </div>

                  <div className="excel-button-list">
                    <Anchor
                      text="검색 키워드 업로드 템플릿"
                      isUnderLine
                      color="primary"
                      href={SEARCH_WORD_TEMPLATE_XLSX_URL}
                      target="_blank"
                    />

                    <ExcelUploadForm
                      onChange={(file) => setRecommendSearchWordItemListExcelUpload(file)}
                      btnText="검색 키워드 엑셀 업로드"
                    />

                    <Button
                      isRadius
                      color="light"
                      text="엑셀 다운로드"
                      onClick={getSelectedRecommendSearchWordItemListExcelDownload}
                    />
                  </div>
                </div>
              ),
              list: selectedItemList.list,
              canDrag: true,
              onDragEnd: (newList) => onDragEndSelectRecommendSearchWordItemList(newList.list),
            }}
            onChange={(action, moveIdList) => selectRecommendSearchWordItemList(action, moveIdList)}
          />
        </div>
      </Panel>
    );
  }
}

export default RecommendSearchWordSaveItemList;
